module.exports = __webpack_public_path__ + "img/water-green4.3c6f0442.png";